export default "__VITE_ASSET__BzFEbjoE__"